import { equals, reduce, remove, indexOf, pickBy, unless, isNil, replace, toUpper } from 'ramda';
var includesTimes = function includesTimes(times, item, items) {
  return items.filter(equals(item)).length === times;
};
var withoutOnce = function withoutOnce(itemsToRemove, removableItems) {
  return reduce(function (itemAccumulator, itemToRemove) {
    return remove(indexOf(itemToRemove, itemAccumulator), 1, itemAccumulator);
  }, removableItems, itemsToRemove);
};
var pickFunctions = pickBy(function (value) {
  return typeof value === 'function';
});
var noop = function noop() {};
var alwaysNull = function alwaysNull() {
  return null;
};
var capitalize = unless(isNil, replace(/^./, toUpper));
export { alwaysNull, capitalize, includesTimes, noop, pickFunctions, withoutOnce };